import { StandardEvents } from '@shopify/events';

/**
 * Swaps in the selected variant's details when the variant picker changes.
 * Same pattern as product-price.js: the variant picker re-renders the section and passes the
 * new HTML on the productSelect event; we copy our block's text out of it.
 */
class FfVariantDetails extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
  }

  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const fresh = detail.html.querySelector(`ff-variant-details[data-block-id="${this.dataset.blockId}"] [ref="text"]`);
        const current = this.querySelector('[ref="text"]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ff-variant-details]', error);
      });
  };
}

if (!customElements.get('ff-variant-details')) customElements.define('ff-variant-details', FfVariantDetails);
